import React from 'react';
import '../Error/Error.scss';

const Error = () =>
  <main>
    <div className="container">
      <div className="row">
        <div className="col-xs-12">
          <h1 className="heading-underline-large">Oops. Something went wrong</h1>
          <p className="error-text">
            {'It\'s not you, it\'s us. Please give it another go at'}
            <a href="https://www.skinny.co.nz/broadband/"> www.skinny.co.nz/broadband </a>
            or chat with our team below. Any payments made will be refunded back to your card.
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 error-button-container">
          <a className="btn btn-default" href="https://www.skinny.co.nz/broadband/">
            Back To HOME
          </a>
        </div>
      </div>
    </div>
  </main>
;

export default Error;



/** WEBPACK FOOTER **
 ** ./src/components/Error/Error.js
 **/